<template>
    <div>
      <div v-if="toggle">
        <BaseFCPMap :elementId="mapId" :latitude="latitude" :longitude="longitude" :popupText="popupText" />
      </div>
    </div>
</template>

<script setup>
  /**
   * This component encapsulates the responsibility of displaying a 'pracititioner' map.
   */
   const props = defineProps({
        location: Object,
        toggle: Boolean
    })


    const { location } = props
    const model = useFCPModel()
    const { profile, context } = model
    const { getPlan } = usePlan(profile.value, context.value)
    const plan = ref(getPlan())
    const { locationDetailUrl } = useUrls(context.value)
    const latitude = computed(() => location.location.latitude)
    const longitude = computed(() => location.location.longitude)
    const mapId = computed(() => `map-${location.id}`)
  
    /**
     * TODO:  Is this phone# logic right?  Story is ambiguous?
     */
    const phoneNumber = computed(() => {
        if (location.contactNumbers && location.contactNumbers.length > 0) {
            const contact = location.contactNumbers.find((c) => c.type == 'Appointments')
            return contact ? contact.phoneNumber.parenthesisStyleString : ''
        }

        return ''
    })
  
    const specialties = computed(() => {
        if (location.specialties) {
            if (location.specialties.length < 4) return location.specialties.join()
            const firstThree = location.specialties.slice(0, 3)
            const restLength = location.specialties.length - 3
            return `${firstThree.join()} + ${restLength} more`
        }
    })
  
    function popupText () {
        const { tier } = location
        const showTier = plan.value.isTiered && tier ? true : false
        const tierValue =
            plan.value.tierLabel == 'Benefit Tier'
            ? tier == 1
                ? `${plan.value.tierLabel}: Select`
                : `${plan.value.tierLabel}: Standard`
            : `${plan.value.tierLabel}: ${tier}`

        return `
                <hp5-semantic size-selection="xxs">
                    <div><hp5-link-text-basic size="xxs" href="${locationDetailUrl(location.id)}" text="${location.name}"></hp5-link-text-basic></div>
                    <div><hp5-spacing-vertical sm="xxs"></hp5-spacing-vertical>${showTier ? tierValue : ''}</div>
                    <div>${specialties.value}</div>
                    <div>${phoneNumber.value}</div>
                    <div>${location.distanceInMiles} miles</div>
                </hp5-semantic>
            `
    }
  
</script>